import React, { useState } from 'react';
import { HowManyNumbers } from '../../../../Constants/Constants';
const HowMany = ({ onNext, answers, stepKey, onGoTo }) => {
  const [error, setError] = useState('');
  const [selectedOption, setSelectedOption] = useState(answers[stepKey] || '');

  const handleChange = (value) => {
    setError(''); // Clear error on any change
    setSelectedOption(value);
  };

  const handleContinue = () => {
    console.log('Selected How Many:', selectedOption);
    if (!selectedOption) {
      setError('Please select an option.');
      return;
    }
    onNext(selectedOption);
  };

  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">How many Times?</h2></div>
      <div className="qs-card__body">
        <ul className="qs-list">
          {Object.entries(HowManyNumbers).map(([key, value]) => (
            <li key={key} className="qs-list__item">
              <button 
                className={`qs-check ${selectedOption === key ? 'is-on' : ''}`} 
                onClick={() => handleChange(key)}
              >
                {value}
              </button>
            </li>
          ))}
        </ul>
        <div className="qs-actions">
          <button type="button" className="qs-btn qs-btn--primary" onClick={handleContinue} data-quest-id={152}>
            Continue <span className="qs-arrow">→</span>
          </button>
        </div>
        {error && <p className="qs-error-message" style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
      </div>
    </>
  );
};

export default HowMany;
